var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"m-group-bordered mx-0"},[_c('v-col',{staticClass:"py-4",attrs:{"cols":"12"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }